// extracted by mini-css-extract-plugin
export default {"form":"email-form_form__kIibh","title":"email-form_title__E+46k","description":"email-form_description__8ckBJ","error":"email-form_error__K4sxL"};